import { FolderIcon, PlusIcon } from "@heroicons/react/24/outline";
import type { EmptyStateProps } from "./emptyState.types";

export function EmptyState({ hasProjects, onCreateProject }: EmptyStateProps) {
  return (
    <div className="text-center py-12">
      <FolderIcon className="w-16 h-16 text-raro-gray-300 mx-auto mb-4" />
      <h3 className="text-lg font-semibold text-raro-gray-900 font-montserrat">
        {hasProjects
          ? "Nenhum projeto corresponde aos filtros"
          : "Nenhum projeto encontrado"}
      </h3>
      <p className="text-raro-gray-600 mt-2">
        {hasProjects
          ? "Tente ajustar os filtros de busca"
          : "Comece criando seu primeiro projeto"}
      </p>
      {!hasProjects && (
        <button
          onClick={onCreateProject}
          className="mt-6 inline-flex items-center px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold font-montserrat rounded-xl transition-all"
        >
          <PlusIcon className="w-5 h-5 mr-2" />
          Criar Primeiro Projeto
        </button>
      )}
    </div>
  );
}